<div class="text-center">
  <h1 class="heading-md m-b-24">Content not found</h1>

  <p class="text-secondary">We couldn't find this page.</p>
</div>
